import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { CART_URL } from 'Route/CartPage/CartPage.config';
import { scrollToTop } from 'Util/Browser';

export const LbxPopupFooter = ({ onCloseHandler }) => {
    return (
        <>
            <Link
                className="Button"
                to={CART_URL}
                onClick={() => {
                    scrollToTop();
                    onCloseHandler();
                }}
            >
                {__('Go to cart')}
            </Link>
            <Link
                className="Button Button_isHollow"
                to="#"
                onClick={(e) => {
                    e.preventDefault();
                    onCloseHandler();
                }}
            >
                {__('Continue shopping')}
            </Link>
        </>
    );
};

LbxPopupFooter.propTypes = {
    onCloseHandler: PropTypes.func.isRequired,
};
